import React from 'react';
import { ArrowRight } from 'lucide-react';
import Reveal from '../ui/Reveal';
import SpotCard from './SpotCard';
import { beforeAfterPairs } from '../../data/masterclass';

const BeforeAfterSection: React.FC = () => {
  return (
    <section className="relative py-24 md:py-28">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal className="max-w-2xl">
          <div className="mb-4 flex items-center gap-3">
            <span className="text-sm text-white/30">04</span>
            <span className="eyebrow-mc text-mc-fuchsia">Antes vs. después</span>
          </div>
          <h2 className="font-display text-3xl font-bold leading-[1.1] md:text-5xl">
            Cambia la forma en que utilizas la IA
          </h2>
        </Reveal>

        <div className="mt-14 max-w-4xl space-y-4">
          {beforeAfterPairs.map((pair, index) => (
            <Reveal key={pair.before} delay={index * 80}>
              <div className="grid items-stretch gap-4 md:grid-cols-[1fr_auto_1fr]">
                <div className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-md">
                  <span className="eyebrow-mc text-white/35">De</span>
                  <p className="mt-2 text-white/65">{pair.before}</p>
                </div>
                <div className="hidden place-items-center md:grid">
                  <ArrowRight size={24} className="text-mc-fuchsia" />
                </div>
                <SpotCard className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-md">
                  <span className="eyebrow-mc text-gradient-mc">A</span>
                  <p className="mt-2 font-medium text-white">{pair.after}</p>
                </SpotCard>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
